export default "__VITE_ASSET__4fa930c3__"